/**
 * Requests the user's location permissions.
 * Returns a Promise that resolves to the GeolocationPosition if granted,
 * or rejects with an error if denied or unavailable.
 */
export function requestLocationPermission(): Promise<GeolocationPosition> {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by this browser.'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => resolve(position),
      (error) => reject(error)
    );
  });
}
